import { Outlet } from 'react-router';

import Foot from './foot';

const LayoutAll = () => {
    return (
        <>
            <Outlet />
            <Foot />
        </>
    );
};

export default LayoutAll;
